import { RouteComponentProps, useNavigate } from '@reach/router';
import { AppPath, PUBLIC_SITE_URL } from 'appConstants';
import { ChoosePackageForm } from 'components/choosePackageForm/ChoosePackageForm';
import ConfirmationBox from 'components/confirmationBox/ConfirmationBox';
import FormHeader from 'components/formHeader/FormHeader';
import PaymentDetailsForm from 'components/paymentDetailsForm/PaymentDetailsForm';
import { PaymentTypeForm } from 'components/paymentTypeForm/PaymentTypeForm';
import ProfileDetailsForm from 'components/profileDetailsForm/ProfileDetailsForm';
import SchoolDetailsForm from 'components/schoolDetailsForm/SchoolDetailsForm';
import Page from 'components/shared/Page';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearPackageForm,
  clearPoNumber,
  clearSchoolDetails,
  setRegistrationToken,
  setValidPromoCode,
} from 'reducers/misc';
import { SubscribeParser, SubscriptionStep } from './models';

const SUCCESS_MESSAGE = {
  title: 'Congratulations',
  message:
    'Your school account has been created successfully. You will shortly receive an email to confirm that your account has been made live',
  buttonText: 'Sign in',
};

const INVOICE_SUCCESS_MESSAGE = {
  title: 'Congratulations',
  message:
    'Your school account has been created successfully. You will shortly receive an email to confirm that your account has been made live',
  buttonText: 'Sign in',
};

export const Subscribe: React.FC<RouteComponentProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [subscriptionStep, setSubscriptionStep] = useState<SubscriptionStep>(
    SubscriptionStep.CHOOSE_PACKAGE
  );
  const [subscriptionIsComplete, setSubscriptionIsComplete] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearSchoolDetails());
      dispatch(setRegistrationToken(''));
      dispatch(clearPackageForm());
      dispatch(setValidPromoCode(''));
      dispatch(clearPoNumber());
    };
  }, []);

  return (
    <Page isPublic className={'SubscribePage'}>
      {subscriptionIsComplete ? (
        <div className="Success">
          <div className="ConfirmationBoxContainer">
            <ConfirmationBox
              {...SUCCESS_MESSAGE}
              buttonOnClick={() => navigate(AppPath.SIGN_IN)}
            />
          </div>
        </div>
      ) : (
        <div className="Content WidthContent HeightContent">
          <div className="SubscriptionPageHead">
            {subscriptionStep === 0 &&
              <div className="WhatsIncludedBtn">
                <a
                  aria-current="page"
                  className="Btn BtnOrange"
                  href={`${PUBLIC_SITE_URL}/pricing`}
                >
                  What's included?
                </a>
              </div>            
            }
            <FormHeader
              activeStep={subscriptionStep < 5 ? subscriptionStep + 1 : 5}
              numOfSteps={5}
              title={SubscribeParser.getPageHeaderInfo(subscriptionStep).title}
              nextStep={
                SubscribeParser.getPageHeaderInfo(subscriptionStep).nextStep
              }
            />
          </div>
          {subscriptionStep === SubscriptionStep.CHOOSE_PACKAGE ? (
            <ChoosePackageForm
              onSubmit={() =>
                setSubscriptionStep(SubscriptionStep.SCHOOL_DETAILS)
              }
            />
          ) : subscriptionStep === SubscriptionStep.SCHOOL_DETAILS ? (
            <SchoolDetailsForm
              onSubmit={() =>
                setSubscriptionStep(SubscriptionStep.PROFILE_DETAILS)
              }
            />
          ) : subscriptionStep === SubscriptionStep.PROFILE_DETAILS ? (
            <ProfileDetailsForm
              onSubmit={() =>
                setSubscriptionStep(SubscriptionStep.PAYMENT_TYPE)
              }
            />
          ) : subscriptionStep === SubscriptionStep.PAYMENT_TYPE ? (
            <PaymentTypeForm
              onSubmit={(typeOfPayment: 'card' | 'invoice') => {
                if (typeOfPayment === 'card') {
                  setSubscriptionStep(SubscriptionStep.PAYMENT_DETAILS);
                } else {
                  setSubscriptionStep(SubscriptionStep.CONFIRMATION);
                }
              }}
            />
          ) : subscriptionStep === SubscriptionStep.PAYMENT_DETAILS ? (
            <PaymentDetailsForm
              onSubmit={() => {
                setSubscriptionIsComplete(true);
              }}
            />
          ) : subscriptionStep === SubscriptionStep.CONFIRMATION ? (
            <div className="Success">
              <div className="ConfirmationBoxContainer">
                <ConfirmationBox
                  {...INVOICE_SUCCESS_MESSAGE}
                  buttonOnClick={() => navigate(AppPath.SIGN_IN)}
                />
              </div>
            </div>
          ) : null}
        </div>
      )}
    </Page>
  );
};
